import { z } from "zod";
import { ScheduleCreateBody } from "./schedule.js";
// One item in a bulk reload. The frontend already knows the app name from
// the listing — passing it through saves us a server-side lookup.
const BulkReloadItem = z.object({
    connectionId: z.number().int().positive(),
    appId: z.string().min(1),
    appName: z.string().min(1),
    partial: z.boolean().optional(),
});
export const BulkReloadBody = z.object({
    items: z.array(BulkReloadItem).min(1).max(200),
    operationName: z.string().max(160).optional(),
});
// Per-item outcome — the API processes the batch best-effort, so partial
// success is normal. UI renders successes + failures separately.
const BulkReloadItemResult = z.object({
    appId: z.string(),
    appName: z.string(),
    connectionId: z.number().int(),
    ok: z.boolean(),
    reloadId: z.string().nullable(),
    qlikReloadId: z.string().nullable(),
    errorCode: z.string().nullable(),
    errorMessage: z.string().nullable(),
});
export const BulkReloadResponse = z.object({
    operationId: z.string(),
    acceptedCount: z.number().int(),
    rejectedCount: z.number().int(),
    results: z.array(BulkReloadItemResult),
});
// Bulk schedule create — one template, applied to many apps. The frontend
// supplies the template (no per-item appId in `template`) and the list of
// targets.
const BulkScheduleTarget = z.object({
    connectionId: z.number().int().positive(),
    appId: z.string().min(1),
    appName: z.string().min(1),
});
// Re-use the regular create body, minus the per-app fields (server fills them).
export const BulkScheduleTemplate = ScheduleCreateBody.innerType().omit({
    connectionId: true,
    appId: true,
    appName: true,
});
export const BulkScheduleBody = z.object({
    template: BulkScheduleTemplate,
    targets: z.array(BulkScheduleTarget).min(1).max(100),
    // If true, each schedule's name is the template name + " · {appName}".
    // Useful for "Daily reload" → "Daily reload · Sales Dashboard".
    appendAppNameToScheduleName: z.boolean().default(true),
});
const BulkScheduleItemResult = z.object({
    appId: z.string(),
    appName: z.string(),
    connectionId: z.number().int(),
    ok: z.boolean(),
    scheduleId: z.string().nullable(),
    scheduleDbId: z.number().int().nullable(),
    errorCode: z.string().nullable(),
    errorMessage: z.string().nullable(),
});
export const BulkScheduleResponse = z.object({
    operationId: z.string(),
    acceptedCount: z.number().int(),
    rejectedCount: z.number().int(),
    results: z.array(BulkScheduleItemResult),
});
//# sourceMappingURL=bulk.js.map